module.exports = __webpack_public_path__ + "static/img/image 12@2x.a60cf2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images_member/20230804/image 12@2x.png
// module id = I/hu
// module chunks = 1